var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"}),_c('div',{staticClass:"copyright text-center"},[_c('b',[_vm._v("© "+_vm._s(new Date().getFullYear()))]),_c('b',[_c('span',{staticClass:"text-primary"},[_vm._v(" "+_vm._s(_vm.translate(_vm.locale.system)))])])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b51f00c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 